/* @flow */

import * as React from 'react';

import type {
    GetSuggestedReplies_suggestedReplies as SuggestedReplies,
    GetSuggestedReplies_suggestedReplies_replies as SuggestedReply,
} from 'nutshell-graphql-types';

import {SuggestedReplyContainer} from './index';

type Props = {|
    suggestedReplies: ?SuggestedReplies,
    isLoading: ?boolean,
    onCardClicked: (reply: SuggestedReply) => void,
    variant: 'full' | 'sparse',
|};

export function SuggestedReplyWrapper(props: Props) {
    const {variant = 'sparse'} = props;

    return (
        <SuggestedReplyContainer
            suggestedReplies={props.suggestedReplies}
            isLoading={props.isLoading}
            onCardClicked={props.onCardClicked}
            variant={variant}
        />
    );
}
